/**
 * @file index.js
 * @author Daniel Aguirre
 * @description Initialize TreatmentOptions View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './TreatmentOptionsView';

export const mapStateToPropsTreatmentOptions = mapStateToProps;
export const mapDispatchToPropsTreatmentOptions = mapDispatchToProps;

export default connect(
  mapStateToPropsTreatmentOptions,
  mapDispatchToPropsTreatmentOptions
)(View);
